import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import adminRoutes from './portalroutes/AdminRoutes';
import customerroutes from '@/router/portalroutes/CustomeRoutes';
import LandingPage from '@/views/LandingPage.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "landing",
    component: LandingPage,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  ...customerroutes,
  ...adminRoutes,
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
